export default "__VITE_ASSET__CXAVhdRv__"